import { createFileRoute, Outlet } from "@tanstack/react-router"

import { Crumb } from "@/utilities/types/local"

export const Route = createFileRoute("/_authenticated/account/passes")({
  staticData: {
    pageName: "Passes",
  },
  loader: () => {
    return {
      crumb: { translationKey: "park:myPasses.header" } as Crumb,
    }
  },
  component: Outlet,
})
